const typeFormToLogo: any = {
    generic: `logo-lbi`,
    hektor: `logo-hektor`,
};

export default typeFormToLogo;
